import React, { useMemo } from "react";

const SmallLogo = ({ height = 14, width = 14.5 }) => {
  const svgContent = useMemo(() => {
    return (
      <svg
        id="Group_30812"
        data-name="Group 30812"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13.903 14.493"
      >
        <path
          id="Path_17530"
          data-name="Path 17530"
          d="M26.132,14.809V12H15.01v2.809"
          transform="translate(-15.008 -12)"
          fill="#0ad172"
        />
        <path
          id="Path_17531"
          data-name="Path 17531"
          d="M15.009,21.1h2.809V12H15.009"
          transform="translate(-15.007 -12)"
          fill="#0ad172"
        />
        <path
          id="Path_17534"
          data-name="Path 17534"
          d="M71.463,26.551v7.806l2.779-2.022V29.3Z"
          transform="translate(-60.339 -23.684)"
          fill="#25f290"
        />
        <path
          id="Path_17532"
          data-name="Path 17532"
          d="M21.687,55.8,15,50.461,16.966,48.5l4.742,3.764Z"
          transform="translate(-15 -41.305)"
          fill="#0ad172"
        />
        <path
          id="Path_17533"
          data-name="Path 17533"
          d="M47.91,55.8,54.6,50.461,52.631,48.5,47.889,52.26Z"
          transform="translate(-41.41 -41.305)"
          fill="#25f290"
        />
      </svg>
    );
  });

  return svgContent;
};

export default SmallLogo;



// WEBPACK FOOTER //
// ./src/assets/SmallLogo.jsx